module.exports = __webpack_public_path__ + "img/ytb.f6a3d54e.svg";